import { z } from 'zod';
import { templateBaseSchema } from './base';

export const templateTextEditorSchema = templateBaseSchema.extend({
  type: z.literal('textEditor'),
  content: z.string(),
});

export type TemplateTextEditorV1 = z.infer<typeof templateTextEditorSchema>;
